import { Controller } from "@hotwired/stimulus"
import { Drawer } from "flowbite"

const drawerOptions = {
  placement: 'right',
  backdrop: true,
  bodyScrolling: false,
  edge: false,
  edgeOffset: '',
  backdropClasses: 'bg-darkblue/[.1] fixed inset-0 z-52',
}

export default class extends Controller {
  static targets = ['drawer']

  initialize() {
    this.handleFrameLoad = this.handleFrameLoad.bind(this)
    this.hide = this.hide.bind(this)
  }

  connect() {
    this.drawer = new Drawer(this.drawerTarget, drawerOptions)
    document.addEventListener("turbo:before-stream-render", this.handleFrameLoad)
    document.addEventListener("drawer:close", this.hide)
  }

  disconnect() {
    this.drawer = null
    document.removeEventListener("turbo:before-stream-render", this.handleFrameLoad)
  }

  handleFrameLoad(event) {
    const frameId = event.target?.target
    if (frameId === "drawer_content")
      this.drawer.show()
  }

  hide() {
    this.drawer.hide()
  }
}
